export const FUNDRAISER_TYPES = [
  'Medical',
  'Education',
  'Religious',
  'Wedding',
  'Funeral',
  'Community Service Organization (CSO)',
  'Business',
  'Other',
]

export const DURATIONS = ['30 days', '60 days', '90 days']

export const CURRENCIES = [
  { code: 'KES', label: 'KES' },
  { code: 'UGX', label: 'UGX' },
  { code: 'TZS', label: 'TZS' },
]

export const CURRENCY_PHONE_MAP = {
  KES: {
    countryCode: 'KE',
    dialCode: '+254',
    countryName: 'Kenya',
    flag: '🇰🇪',
  },
  UGX: {
    countryCode: 'UG',
    dialCode: '+256',
    countryName: 'Uganda',
    flag: '🇺🇬',
  },
  TZS: {
    countryCode: 'TZ',
    dialCode: '+255',
    countryName: 'Tanzania',
    flag: '🇹🇿',
  },
}

export const AMOUNT_LIMITS = {
  KES: {
    min: 50000,
    max: 100000000,
  },
  UGX: {
    min: 2500000,
    max: 1000000000,
  },
  TZS: {
    min: 2500000,
    max: 1000000000,
  },
}

export const REGISTRATION_STEPS = {
  STEP_1: 1,
  STEP_2: 2,
  TOTAL: 2,
}
